// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"17c28716","459":"4b767730"}[chunkId] + ".chunk.js";
};